import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ImportCartsCTA, TooltipStyled } from 'src/components';
import { useCurrentUser } from 'src/hooks';
import SacPlusIcon from 'src/images/icons/sac-plus-fire-cart.svg?react';

type Props = {
  displayedCartsLength: number;
  hasNextPage: boolean;
  fetchingNextPage: boolean;
  loadMoreCarts: () => void;
};

export const CartHistoryFooter = ({
  displayedCartsLength,
  hasNextPage,
  fetchingNextPage,
  loadMoreCarts,
}: Props) => {
  const { t } = useTranslation();
  const { user } = useCurrentUser();

  return (
    <div className='flex w-full flex-col items-center justify-between gap-4 border-b border-blueGray p-6 md:flex-row'>
      {!user || !user.subscription || user!.subscription?.tier === 'free' ? (
        <>
          <div className='flex flex-row flex-wrap justify-center gap-x-4 gap-y-4 sm:items-start sm:justify-start'>
            <p className='text-nowrap text-center font-secondary text-base font-normal'>
              <Trans
                i18nKey={t('history.showing_x_of_y_carts', {
                  count: user!.carts.length,
                  displayedCartsLength,
                })}
                components={[<strong />]}
              />
            </p>
            <ImportCartsCTA />
          </div>
          <div className='flex flex-col flex-nowrap items-center justify-center gap-2 md:flex-row md:gap-4'>
            <span className='text-pretty text-center font-primary text-lg font-semibold xs:text-xl'>
              {t('history.access_your_full_cart_history')}
            </span>
            <div className='inline-flex flex-nowrap items-center justify-center'>
              <Link to='/plus/upgrade'>
                <button className='button-primary h-12'>
                  <span className='font-secondary text-base font-bold'>
                    {t('history.upgrade_now')}
                  </span>
                </button>
              </Link>
              <div className='flex h-12 w-[75px] items-center justify-center overflow-visible'>
                <SacPlusIcon
                  title='Full cart with fire emoji'
                  className='h-auto w-[75px]'
                />
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className='flex flex-col items-center justify-center gap-x-3 gap-y-2 sm:flex-row'>
            <p className='text-200 text-balance text-center'>
              <Trans
                i18nKey={t('history.showing_x_of_y_carts', {
                  count: user!.carts.length,
                  displayedCartsLength,
                })}
                components={[<strong />]}
              />
            </p>
            <TooltipStyled
              title={t('history.no_more_carts_to_display')}
              placement='top'
              disableHoverListener={hasNextPage || fetchingNextPage}
              disableTouchListener={hasNextPage || fetchingNextPage}
            >
              <span onClick={() => loadMoreCarts()}>
                <button
                  className='button-secondary h-12 w-full max-w-fit'
                  disabled={
                    !hasNextPage ||
                    fetchingNextPage ||
                    displayedCartsLength === user!.carts?.length
                  }
                >
                  {t('history.load_more_carts')}
                </button>
              </span>
            </TooltipStyled>
            <ImportCartsCTA />
          </div>
          {/* {user.subscription.tier === 'personal' && (
            <div className='flex w-fit flex-col flex-wrap items-center justify-end gap-x-4 gap-y-2 md:flex-row'>
              <p className='text-200 text-nowrap text-center font-secondary text-base font-normal'>
                Need more users?
              </p>
              <p className='heading-100 text-nowrap text-center font-primary text-base font-semibold'>
                Upgrade to&nbsp;
                <Link
                  to='/plus/upgrade'
                  className='text-primary transition-all hover:underline'
                >
                  Organization+
                </Link>
              </p>
            </div>
          )} */}
        </>
      )}
    </div>
  );
};
